import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "timestampToDate"})
export class TimestampToDatePipe implements PipeTransform {
  transform(timestamp: number): Date {
    // console.log(timestamp, new Date(timestamp * 1000));
    return new Date(timestamp * 1000);
  }
}
